import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./switch-component.css.ts.vanilla.css-mistica.js";
var n = {
    default: "q0hp3au q0hp3as q0hp3ar _1y2v1nfb0 _1y2v1nffk _1y2v1nfb7 _1y2v1nfdo",
    ios: "q0hp3av q0hp3at q0hp3ar _1y2v1nfb0 _1y2v1nffk _1y2v1nfb7 _1y2v1nfdo",
    checked: "q0hp3aw q0hp3as q0hp3ar _1y2v1nfb0 _1y2v1nffk _1y2v1nfb7 _1y2v1nfdo",
    checkedIos: "q0hp3ax q0hp3at q0hp3ar _1y2v1nfb0 _1y2v1nffk _1y2v1nfb7 _1y2v1nfdo"
}, f = {
    default: "q0hp3ai q0hp3ah _1y2v1nfb7",
    ios: "q0hp3aj q0hp3ah _1y2v1nfb7",
    checked: "q0hp3ak q0hp3ah _1y2v1nfb7",
    checkedIos: "q0hp3al q0hp3ah _1y2v1nfb7"
}, v = {
    default: "q0hp3a6 _1y2v1nfb9 _1y2v1nfe4",
    ios: "q0hp3a7 _1y2v1nfb9 _1y2v1nfe4",
    disabled: "q0hp3a8 _1y2v1nfb9 _1y2v1nfe4",
    disabledIos: "q0hp3a9 _1y2v1nfb9 _1y2v1nfe4"
}, p = "q0hp3an q0hp3am", q = "q0hp3ao q0hp3am", y = "q0hp3ap", _ = {
    default: "q0hp3ac q0hp3ab _1y2v1nfaz",
    ios: "q0hp3ad q0hp3ab _1y2v1nfaz"
}, b = "q0hp3af _1y2v1nfb7 _1y2v1nfe5";
export { n as ballVariants, f as barVariants, v as checkboxVariants, p as container, q as containerDisabled, y as disabled, _ as switchCheckboxContainerVariants, b as switchCheckboxLabel };
